import React from 'react';
import { graphql } from 'gatsby';
import NumberStatement from '../components/NumberStatement';
import LitImage from './images/LitImage';
const ModularHeaderNumberText = ({ data }) => {
  const { headerNumberTextContent, backgroundColor, header, image, idContent } =
    data;
  return (
    <div className="modular-header-number-text-container">
      {image && (
        <div className="modular-header-number-text-image">
          <LitImage image={image} alt="drawn icon" />
        </div>
      )}
      <NumberStatement
        numberStatementData={headerNumberTextContent}
        backgroundColor={backgroundColor}
        header={header}
        id={idContent}
        globalWidth={true}
      />
    </div>
  );
};
export default ModularHeaderNumberText;
export const fragment = graphql`
  fragment ModularHeaderNumberText on DatoCmsHeaderNumberText {
    internal {
      type
    }
    idContent
    backgroundColor
    header {
      value
    }
    image {
      gatsbyImageData
    }
    headerNumberTextContent {
      heading {
        value
      }
      body {
        value
      }
      featureImage {
        gatsbyImageData
      }
    }
  }
`;
